/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBASECurrentSettings,
  setDefaultSettings,
} from "../../store/BASE/settingsSlice";
import _ from "../../../@lodash";
import useThemeMediaQuery from "../../../@BASE/hooks/useThemeMediaQuery";
import { navbarToggle, navbarToggleMobile } from "../../store/BASE/navbarSlice";
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";

function NavbarToggleButton(props) {
  const {
		className = '',
		children = (
			<BASESvgIcon size={20} color="action">
				heroicons-outline:view-list
			</BASESvgIcon>
		),
	} = props;
  const dispatch = useDispatch();
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));
  const settings = useSelector(selectBASECurrentSettings);
  const { config } = settings.layout;

  return (
    <IconButton
      className={className}
      color="inherit"
      size="small"
      onClick={(ev) => {
        if (isMobile) {
          dispatch(navbarToggleMobile());
        } else if (config.navbar.style === "style-2") {
          dispatch(
            setDefaultSettings(
              _.set(
                {},
                "layout.config.navbar.folded",
                !settings.layout.config.navbar.folded
              )
            )
          );
        } else {
          dispatch(navbarToggle());
        }
      }}
    >
      {children}
    </IconButton>
  );
}

// NavbarToggleButton.defaultProps = {
//   children: (
//     <BASESvgIcon size={20} color="action">
//       heroicons-outline:view-list
//     </BASESvgIcon>
//   ),
// };

export default NavbarToggleButton;
